export default {
  styleOverrides: {
    paperWidthXs: {
      maxWidth: 500,
    },
  },
};